import type { DropDownMenu } from '@/components/elements/HeaderLink/dropdown';
import {
  Box,
  Button,
  Icon,
  IconButton,
  Link as Clink,
  Modal,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import React, { Fragment } from 'react';
import { useTranslation } from 'next-i18next';
import { MdClose } from 'react-icons/md';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  elements: DropDownMenu[];
};
const MenuOverlay = ({ isOpen, onClose, elements }: Props) => {
  const { pathname, push } = useRouter();
  const { t } = useTranslation(`common`);
  return (
    <Modal
      blockScrollOnMount={false}
      scrollBehavior="inside"
      size="full"
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        my="0"
        position="relative"
      >
        <IconButton
          position="absolute"
          top={12}
          right={8}
          aria-label="close menu"
          icon={<Icon as={MdClose} boxSize={6} />}
          variant="ghost"
          onClick={onClose}
        />
        {elements.map((item) => (
          <Fragment key={item.title}>
            <Link key={item.link} href={item.link} passHref>
              <Clink fontWeight="bold" fontSize="2xl" mb={9} onClick={onClose}>
                {item.title}
              </Clink>
            </Link>
            {item.subMenu.map((el) => (
              <Link
                key={el.link + el.element}
                href={
                  pathname === el.link && el.element
                    ? `#${el.element}`
                    : el.link
                }
                passHref
              >
                <Clink onClick={onClose} fontSize="lg" mb={9} cursor="pointer">
                  {el.title}
                </Clink>
              </Link>
            ))}
          </Fragment>
        ))}
        <Button
          size="lg"
          fontWeight="bold"
          fontSize="2xl"
          variant="ghost"
          colorScheme="blue"
          color="brand.500"
          onClick={() => push(`/download`)}
        >
          {t(`navigation.download`)}
        </Button>
      </ModalContent>
    </Modal>
  );
};

export default MenuOverlay;
